import { fromJS } from 'immutable';

import {
  CHANGE_LOCALE,
  DEFAULT_LOCALE,
} from 'store/LanguageProvider/constants';

interface ChangeLocaleAction {
  type: typeof CHANGE_LOCALE;
  locale: string;
}

const initialState = fromJS({
  locale: DEFAULT_LOCALE,
});

const languageReducer = (state = initialState, action: ChangeLocaleAction) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return state.set('locale', action.locale);
    default:
      return state;
  }
};

export default languageReducer;
